import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import ManageFiles from "components/private/manage-files/ManageFiles";
import { Route, Switch } from "react-router-dom";
import { useAppContext } from "../../context/AuthContext";
import EnumGroup from "../../utils/enum/EnumGroup";
import AllManuscripts from "../private/all-manuscripts/AllManuscripts";
import AllReviewers from "../private/all-reviewers/AllReviewers";
import ArticleDetails from "../private/article-details/ArticleDetails";
import AssistantEditorToDoList from "../private/assistant-editor-to-do-list/AssistantEditorToDoList";
import AssociateEditors from "../private/associate-editors/AssociateEditors";
import AssociateMyArticle from "../private/associate-my-article/AssociateMyArticle";
import AssociateStatistics from "../private/associate-statistics/AssociateStatistics";
import Blacklist from "../private/blacklist/Blacklist";
import CheckManuscript from "../private/check-manuscript/CheckManuscript";
import Correction from "../private/correction/Correction";
import DecideOnStatus from "../private/decide-on-status/DecideOnStatus";
import Header from "../private/header/Header";
import Home from "../private/home/Home";
import Keywords from "../private/keywords/Keywords";
import ArticleDraft from "../private/manuscript/draft/ArticleDraft";
import ArticleRevision from "../private/manuscript/revision/ArticleRevision";
import Submit from "../private/manuscript/submit/Submit";
import ArticleView from "../private/manuscript/view/ArticleView";
import Menu from "../private/menu/Menu";
import OverrideArticle from "../private/override-article/OverrideArticle";
import Profile from "../private/profile/Profile";
import ReviewHistory from "../private/review-history/ReviewHistory";
import Review from "../private/review/Review";
import ReviewDecide from "../private/review/decide/ReviewDecide";
import ReviewerSelection from "../private/reviewer-selection/ReviewerSelection";
import ReviewersStatistics from "../private/reviewer-statistics/ReviewersStatistics";
import ReviewerToDoList from "../private/reviewer-to-do-list/ReviewerToDoList";
import SearchManuscripts from "../private/search-manuscsripts/SearchManuscript";
import Tickets from "../private/tickets/Ticket";
import TicketEdit from "../private/tickets/edit/TicketEdit";
import TicketListReview from "../private/tickets/list/TicketListReview";
import ToDoList from "../private/to-do-list/ToDoList";
import UploadRevision from "../private/upload-revision/UploadRevision";
import UsersEdit from "../private/users/UserEdit";
import Users from "../private/users/Users";
import ErrorPage from "../system/error-page/ErrorPage";
import useStyles from "./PrivateRouteStyle";

export default function PrivateRoute() {
  const classes = useStyles();
  const { authData } = useAppContext();

  const canViewUser = [EnumGroup.ASSOCIATE_EDITOR, EnumGroup.EDITOR, EnumGroup.ASSISTANT].includes(
    authData?.user.group.group
  );

  return (
    <>
      <div className={classes.root}>
        <CssBaseline />
        <Header />
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <div className={classes.toolbar}></div>
          <Menu />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/manuscript/revision" component={ArticleRevision} />
            <Route exact path="/manuscript/view" component={ArticleView} />
            <Route exact path="/manuscript/draft" component={ArticleDraft} />
            <Route exact path="/manuscript/submit/:id?" component={Submit} />
            <Route exact path="/manuscript/submit" component={Submit} />
            <Route exact path="/manuscript/all" component={AllManuscripts} />
            <Route exact path="/associate/myArticle" component={AssociateMyArticle} />
            <Route exact path="/tickets" component={Tickets} />
            <Route exact path="/tickets/editTicket/:id" component={TicketEdit} />
            <Route exact path="/ticketsReview" component={TicketListReview} />
            <Route exact path="/keywords" component={Keywords} />
            <Route exact path="/blacklist" component={Blacklist} />
            {canViewUser && <Route exact path="/users" component={Users} />}
            <Route exact path="/user/edit/:id?" component={UsersEdit} />
            <Route exact path="/associateEditors" component={AssociateEditors} />
            <Route exact path="/allReviewers" component={AllReviewers} />
            <Route exact path="/searchManuscripts" component={SearchManuscripts} />
            <Route exact path="/toDoList" component={ToDoList} />
            <Route exact path="/reviewerToDoList" component={ReviewerToDoList} />
            <Route exact path="/reviewersStatistics" component={ReviewersStatistics} />
            <Route exact path="/associateStatistics" component={AssociateStatistics} />
            <Route exact path="/reviewerSelection/:id" component={ReviewerSelection} />
            <Route exact path="/overrideArticle/:id" component={OverrideArticle} />
            <Route exact path="/decideOnStatus/:id" component={DecideOnStatus} />
            <Route exact path="/reviewHistory" component={ReviewHistory} />
            <Route exact path="/articleDetails/:id" component={ArticleDetails} />
            <Route exact path="/assitantEditorList" component={AssistantEditorToDoList} />
            <Route exact path="/checkManuscript/:id" component={CheckManuscript} />
            <Route exact path="/manageFiles/:id" component={ManageFiles} />
            <Route exact path="/:articleID/review/:articleReviewerId" component={Review} />
            <Route exact path="/:articleID/review/:articleReviewerId/:status" component={ReviewDecide} />
            <Route exact path="/uploadRevision/:id" component={UploadRevision} />
            <Route exact path="/correction/:id" component={Correction} />
            <Route component={ErrorPage} />
          </Switch>
        </main>
      </div>
    </>
  );
}
